import {
  deleteRequest,
  getRequest,
  postRequest,
  putRequest,
} from "./api.request";

const DEPARTMENT_PATH = "/department/v1";

export const getDepartmentApi = async (params) =>
  await getRequest(DEPARTMENT_PATH, params);

export const getDepartmentByIdApi = async (id) =>
  await getRequest(`${DEPARTMENT_PATH}/${id}`);

export const addDepartmentApi = async (data) =>
  await postRequest(DEPARTMENT_PATH, data);

export const updateDepartmentApi = async (id, data) =>
  await putRequest(`${DEPARTMENT_PATH}/${id}`, data);

export const deleteDepartmentByIdApi = async (id) =>
  await deleteRequest(`${DEPARTMENT_PATH}/${id}`);
